module.exports = __webpack_public_path__ + "static/media/scooter_bag.0f6240dc.svg";